import { render, staticRenderFns } from "./PauseIcon.vue?vue&type=template&id=2d9509c0&"
import script from "./PauseIcon.vue?vue&type=script&lang=js&"
export * from "./PauseIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports